import { useApiClient } from '@portals-platform/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CertificateResponse } from '../api/responses.js';
import { queryKeys } from '../query-keys.js';

export function useRequestCertificateRenewal() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<CertificateResponse, Error, string>({
    mutationFn: (certificateId) =>
      client
        .post<CertificateResponse>(ENDPOINTS.certificateRenewalRequest(certificateId))
        .then((response) => response.data),
    // The status changes server-side, so both the list and the open detail page go stale.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.certificates() }),
  });
}
